import { DE, EN, getSupportedLanguage } from './languages'

// Datenschutz und Impressum gibt es auf aivy.app nur auf Deutsch und Englisch.
// NL und FR bekommen deshalb die englische Seite, damit die Einwilligung nicht
// auf ein rein deutsches Dokument verweist
const LEGAL_LINKS = {
  [DE]: {
    privacy: 'https://www.aivy.app/datenschutz',
    imprint: 'https://www.aivy.app/impressum'
  },
  [EN]: {
    privacy: 'https://www.aivy.app/en/data-protection',
    imprint: 'https://www.aivy.app/en/imprint'
  }
}

export const getLegalLinks = (language) => {
  return LEGAL_LINKS[getSupportedLanguage(language)] || LEGAL_LINKS[EN]
}
